import React from 'react'

import { LanguageSwitchContext } from '../components/layout/header/language-switch/language-switch.context'

export function useLanguageSwitch() {
  const context = React.useContext(LanguageSwitchContext)
  if (!context) {
    throw new Error(
      '`useLanguageSwitch` must be used within a `LanguageSwitchProvider`',
    )
  }

  return context
}
